import React, { createContext, useEffect, useState } from "react";

import { fetchDrivers } from "../services/driverService";

export const DataContext = createContext();

export const DataProvider = ({ children }) => {
  const apiKey = process.env.REACT_APP_API_KEY;

  const [drivers, setDrivers] = useState([]);
  const [loadingDrivers, setLoadingDrivers] = useState(true);
  const [error, setError] = useState(null);

  // Fetch drivers
  useEffect(() => {
    const loadDriverData = async () => {
      try {
        setLoadingDrivers(true);
        // incrementApiCallCount();
        const { data, error } = await fetchDrivers(apiKey);

        if (error) {
          setError(error === "Database overwhelmed" ? "Database overwhelmed, please try again shortly!" : "An unexpected error occurred, please try again.");
        } else {
          setDrivers(data);
          // console.log("Fetched drivers:", data); // Logging the driver data
        }
      } catch (err) {
        console.error("Error loading drivers:", err);
      } finally {
        setLoadingDrivers(false);
      }
    };
    if (drivers.length === 0) loadDriverData();
  }, [apiKey, drivers]); // Dependency

  return (
    <DataContext.Provider
      value={{
        drivers,
        loadingDrivers,
        error,
      }}
    >
      {children}
    </DataContext.Provider>
  );
};
